import { Icon, Hyperlink } from '@sanlam-glacier/app-common/components';
import './GenericErrorIconLink.scss';

interface GenericErrorIconLinkProps {
  path: string;
  title: string;
  icon?: string;
}

export const GenericErrorIconLink = ({ path, title, icon }: GenericErrorIconLinkProps) => {
  return (
    <Hyperlink href={path} className='generic-error-layout-icon-link'>
      {icon && <Icon icon={icon} className='generic-error-layout-icon-link-icon' />}
      <div className='generic-error-layout-icon-link-text'>{title}</div>
    </Hyperlink>
  );
};
